import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-anti-ragging-cell',
  templateUrl: './anti-ragging-cell.component.html',
  styleUrls: ['./anti-ragging-cell.component.scss']
})
export class AntiRaggingCellComponent implements OnInit {

  antiRaggingImages = [
    '/assets/img/facility/anti-ragging-campus/ragging-free-campus-577x400.jpg',
    '/assets/img/facility/anti-ragging-campus/ragging-free-campus2-711x400.jpg',
    '/assets/img/facility/anti-ragging-campus/ragging-free-campus3-711x400.jpg',
    '/assets/img/facility/anti-ragging-campus/ragging-free-campus4-711x400.jpg',
    '/assets/img/facility/anti-ragging-campus/ragging-free-campus5-711x400.jpg',
    '/assets/img/facility/anti-ragging-campus/ragging-free-campus6-711x400.jpg',
    '/assets/img/facility/anti-ragging-campus/ragging-free-campus7-711x400.jpg',
    '/assets/img/facility/anti-ragging-campus/ragging-free-campus8-711x400.jpg',
    '/assets/img/facility/anti-ragging-campus/ragging-free-campus9-600x400.jpg',
    '/assets/img/facility/anti-ragging-campus/ragging-free-campus10-600x400.jpg',
    '/assets/img/facility/anti-ragging-campus/ragging-free-campus11-scaled.jpg',
    '/assets/img/facility/anti-ragging-campus/ragging-free-campus12-600x400.jpg',
    '/assets/img/facility/anti-ragging-campus/ragging-free-campus13-600x400.jpg',
    '/assets/img/facility/anti-ragging-campus/ragging-free-campus14-600x400.jpg',
    '/assets/img/facility/anti-ragging-campus/ragging-free-campus15-267x400.jpg',
    '/assets/img/facility/anti-ragging-campus/ragging-free-campus16-600x400.jpg',
    '/assets/img/facility/anti-ragging-campus/ragging-free-campus17-676x400.jpg',
    '/assets/img/facility/anti-ragging-campus/ragging-free-campus18-623x400.jpg',
    '/assets/img/facility/anti-ragging-campus/ragging-free-campus19-800x376.jpg',
    '/assets/img/facility/anti-ragging-campus/ragging-free-campus20-400x400.jpg',
    '/assets/img/facility/anti-ragging-campus/ragging-free-campus21-400x400.jpg',
    '/assets/img/facility/anti-ragging-campus/ragging-free-campus22-533x400.jpg'
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
